import { Box, Button, Pagination, Table, TableBody, TableContainer, TableHead, TableRow, ThemeProvider } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { darkTheme, Search, SearchIconWrapper, StyledInputBase, StyledTableCell, StyledTableRow } from "../../../styles/styles";
import { BsSearch } from "react-icons/bs";
import { toast } from "react-toastify";
import api from "../../../services/QualityAssurance";
import { useSelector } from "react-redux";
import TableLoader from "../../TableLoader";
import { formatCurrency } from "../../../services/utils";

export const Payment = () => {
    const { admToken, user } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");

    const [pagination, setPagination] = useState({
        pageNumber: 1,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0
    });

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.getPayments(
                admToken,
                user.schoolId
            );
            if (res.status && res.statusCode === 2) {
                setData(res.data)
                setPagination(prev => ({
                    ...prev,
                    totalRecords: res.totalRecord,
                    totalPages: Math.ceil(res.totalRecord / pagination.pageSize),
                    currentPage: res.currentPage || 1
                }));
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    }, [admToken, user.schoolId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleStatusChange = async (ItemId, paymentReference) => {
        if (!ItemId && !paymentReference) return

        try {
            const res = await api.approvePayment(admToken, ItemId, paymentReference);
            if (res.status && res.statusCode === 2) {
                toast.success(res.message || res.data.message || "Staus updated");
                fetchData();
            } else {
                toast.error(res.message || res.data.message || "Failed to update Status");
            }
        } catch (error) {
            console.error("Error updating Status:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        setPagination(prev => ({ ...prev, pageNumber: 1 }));
    };

    const handlePageChange = (event, newPage) => {
        setPagination(prev => ({ ...prev, pageNumber: newPage }));
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchData();
    };

    return (
        <div className="ring-1 ring-[#691e78] rounded-xl overflow-hidden">
            <ThemeProvider theme={darkTheme}>
                <Box sx={{ width: "100%" }}>
                    <Box
                        sx={{
                            pt: 4,
                            background: "rgba(103, 30, 120, 0.1)",
                            height: "100px",
                            pl: { xs: 2.5 },
                        }}
                        onSubmit={handleSearchSubmit}
                    >
                        <Search
                            sx={{
                                width: {
                                    lg: "345px",
                                    md: "330px",
                                    sm: "auto",
                                    xs: "auto",
                                    pl: { xs: 6 },
                                },
                            }}
                        >
                            <SearchIconWrapper>
                                <BsSearch />
                            </SearchIconWrapper>
                            <StyledInputBase
                                placeholder="Search…"
                                inputProps={{ "aria-label": "search" }}
                                value={searchText}
                                onChange={handleSearchChange}
                            />
                        </Search>
                    </Box>
                    <TableContainer>
                        <Table
                            sx={{
                                minWidth: 700,
                                fontFamily: "Gilroy-Regular",
                                borderRadius: "0",
                            }}
                            aria-label="customized table"
                        >
                            <TableHead
                                sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%" }}
                            >
                                <TableRow>
                                    <StyledTableCell>S/N</StyledTableCell>
                                    <StyledTableCell>AdmissionId</StyledTableCell>
                                    <StyledTableCell>Amount paid</StyledTableCell>
                                    <StyledTableCell>status</StyledTableCell>
                                    <StyledTableCell>Bank</StyledTableCell>
                                    <StyledTableCell>Account Number</StyledTableCell>
                                    <StyledTableCell>Account Name</StyledTableCell>
                                    <StyledTableCell>Depositor Name</StyledTableCell>
                                    <StyledTableCell>Narration</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ fontFamily: "Gilroy-Regular", width: "100%" }}>
                                {loading ? (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={6} align="center">
                                            <TableLoader />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ) : data?.length > 0 ? (
                                    data?.map((item, index) => (
                                        <StyledTableRow key={item.id || index}>
                                            <StyledTableCell component="th" scope="row">{index + 1}</StyledTableCell>
                                            <StyledTableCell>{item.itemId}</StyledTableCell>
                                            <StyledTableCell>{formatCurrency(item.paidAmount || 0)}</StyledTableCell>
                                            <StyledTableCell>
                                                <span
                                                    className={`rounded-md px-2 py-1 text-sm font-medium border border-prim
                                                        ary text-primary`}
                                                >
                                                    {item.status}
                                                </span>
                                            </StyledTableCell>
                                            <StyledTableCell>{item.paidByBankName}</StyledTableCell>
                                            <StyledTableCell>{item.paidByAccountNumber}</StyledTableCell>
                                            <StyledTableCell>{item.paidByBankName}</StyledTableCell>
                                            <StyledTableCell>{item.depositorName}</StyledTableCell>
                                            <StyledTableCell>{item.narration}</StyledTableCell>
                                            {item?.status === "Submitted" ?
                                                <StyledTableCell>
                                                    <button
                                                        onClick={() => handleStatusChange(item.itemId, item.paymentReference)}
                                                        className="text-center bg-primary text-white rounded-full px-6 py-2 hover:bg-primary/90 text-sm"
                                                    >
                                                        Approve
                                                    </button>
                                                </StyledTableCell>
                                                : <StyledTableCell></StyledTableCell>
                                            }
                                        </StyledTableRow>
                                    ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={6} align="center">
                                            No activities found
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                        {pagination.totalPages > 1 && (
                            <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 2 }}>
                                <Pagination
                                    count={pagination.totalPages}
                                    page={pagination.currentPage}
                                    onChange={handlePageChange}
                                    color="primary"
                                    sx={{
                                        '& .MuiPaginationItem-root': {
                                            color: '#671E78',
                                        },
                                        '& .Mui-selected': {
                                            backgroundColor: 'rgba(103, 30, 120, 0.1)',
                                        },
                                    }}
                                    showFirstButton
                                    showLastButton
                                />
                            </Box>
                        )}
                    </TableContainer>
                </Box>
            </ThemeProvider>
        </div>
    );
};